import { EEGVersionDetailed } from "../../../types/api.types";

/** Returns a German label for an EEG version, or null for an unmapped version. */
export function getEegVersionLabel(
  eegVersion: EEGVersionDetailed
): string | null {
  switch (eegVersion) {
    case EEGVersionDetailed.BEFORE_EEG_2014:
      return "Vor EEG 2014";
    case EEGVersionDetailed.EEG_2014:
      return "EEG 2014";
    case EEGVersionDetailed.EEG_2017:
      return "EEG 2017";
    case EEGVersionDetailed.EEG_2021:
      return "EEG 2021";
    case EEGVersionDetailed.EEG_2023:
      return "EEG 2023";
    case EEGVersionDetailed.EEG_2025:
      return "EEG 2025";
    default:
      return null;
  }
}
